module.exports = __webpack_public_path__ + "img/logo.4b67fa3a.png";